import React, {useEffect} from "react";
import {LocationService} from "./components/LocationService";
import {useDispatch} from "react-redux";
import {fetchProvinces} from "../../redux/slices/locationSlice";

function Location() {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchProvinces())
  }, [])

  return (
    <>
      <div className="h-auto px-3 -mt-24 md:px-8">
        <div className="container max-w-full mx-auto">
          <div className="px-4 mb-16 grid grid-cols-1">
            <LocationService/>
          </div>
        </div>
      </div>

    </>
  )
}

export default Location
